export default __webpack_public_path__ + "static/media/Karen.a6c42866.png";